let ctx = null;
const KEY = "pl_siren";

export const sirenEnabled = () => localStorage.getItem(KEY) === "1";
export const setSirenEnabled = (on) => localStorage.setItem(KEY, on ? "1" : "0");

export function unlockAudio() {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
  } catch (_e) { /* unsupported */ }
}

export function playSiren(seconds = 2.4) {
  try {
    unlockAudio();
    if (!ctx) return;
    const now = ctx.currentTime;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "square";
    osc.connect(gain); gain.connect(ctx.destination);
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.5, now + 0.05);
    const cycles = Math.floor(seconds / 0.6);
    for (let i = 0; i < cycles; i++) {
      const t = now + i * 0.6;
      osc.frequency.setValueAtTime(620, t);
      osc.frequency.linearRampToValueAtTime(1150, t + 0.3);
      osc.frequency.linearRampToValueAtTime(620, t + 0.6);
    }
    gain.gain.setValueAtTime(0.5, now + seconds - 0.1);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + seconds);
    osc.start(now); osc.stop(now + seconds);
    if (navigator.vibrate) navigator.vibrate([400, 150, 400, 150, 600]);
  } catch (_e) { /* ignore */ }
}

export const isUrgent = (msg = "") => /new boot|overdue|go boot|plate runner/i.test(msg);
